import { Tooltip } from '@material-ui/core';
import classnames from 'classnames';
import * as React from 'react';
import { NavLink as BaseNavLink, NavLinkProps, useRouteMatch } from 'react-router-dom';

interface FLDVNavLinkProps {
  activeClassName: string;
  urlMatch?: string[];
  to?: string;
  tooltip?: string;
  isWithSubmenu?: boolean;
  isActiveSubmenu?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  isWithDropDownmenu?: boolean;
}

const NavLink = React.forwardRef(
  (
    {
      urlMatch,
      tooltip,
      isWithSubmenu,
      isActiveSubmenu,
      activeClassName,
      onClick,
      isWithDropDownmenu,
      ...rest
    }: FLDVNavLinkProps & Omit<NavLinkProps, 'to'>,
    ref: React.Ref<HTMLAnchorElement>,
  ) => {
    const match = useRouteMatch({
      path: urlMatch ?? rest.to,
      exact: rest.exact,
    });

    const handleClick = (
      e: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.MouseEvent<HTMLInputElement, MouseEvent>,
    ) => {
      if (!onClick) return;
      onClick(e as React.MouseEvent<HTMLAnchorElement, MouseEvent>);
    };

    if (isWithSubmenu) {
      return (
        <Tooltip title={tooltip || ''} placement="right">
          <div
            onClick={(e: React.MouseEvent<HTMLInputElement, MouseEvent>) => handleClick(e)}
            data-qa-id={
              urlMatch ? `menuLink-to-sebmenu-${urlMatch[0]?.substring(1).split('/')[0]}` : 'menuLink-to-sebmenu'
            }
            className={classnames({ [activeClassName]: match || isActiveSubmenu }, rest.className)}
          >
            {rest?.children}
          </div>
        </Tooltip>
      );
    }

    return (
      <Tooltip title={tooltip || ''} placement="right">
        <BaseNavLink
          onClick={e => handleClick(e)}
          ref={ref}
          to={{ pathname: rest.to }}
          data-qa-id={`menuLink-to-${rest.to?.substring(1)}`}
          {...rest}
          className={classnames({ [activeClassName]: match || isActiveSubmenu }, rest.className)}
        >
          {rest?.children}
        </BaseNavLink>
      </Tooltip>
    );
  },
);

export default NavLink;
